import React from "react";
import { Provider } from "components/approval-result/ApprovalResultContext";
import { ApprovalResultList } from "components/approval-result/ApprovalResultList";

export const ApprovalResults = () => {
    return (
        <Provider>
            <ApprovalResultList />
        </Provider>
    );
};
